// extracted by mini-css-extract-plugin
module.exports = {"nav":"style_nav__qFD+g"};